<template>
  <div>
    <custom-loading-component/>
    <qr-reader ref="qrReader" @reduceSuccess="commitPay" @success="commitQrCode" @partnerSuccess="commitPartnerQr"/>
    <vs-row vs-type="block" vs-w="12">
      <vs-popup fullscreen :active.sync="isActive" id="orderList" @update:active="handlePopupUpdate">
        <calc v-if="isPosEnabled" ref="calculatorPage" @closeEvent="closeCalculatorPage" @doPay="doPay" @setIsPieced="setIsPieced"
              :totalPrice="separatePaymentPrice"
              :currentDate="currentDate" :currentTime="currentTime"/>
        <calc v-if="!isPosEnabled" ref="calculatorPage" @closeEvent="closeCalculatorPage" @doPay="doPayWithoutPos"
              :totalPrice="separatePaymentPrice"
              :currentDate="currentDate" :currentTime="currentTime"/>
        <div class="payment-screen-layout">
        <vs-row vs-type="flex" vs-w="12" class="p-0 m-0 payment-screen-header">
          <vs-button size="large" color="transparent" class="payment-label bg-primary2 text-white w-full payment-screen-header-btn"
                     icon-pack="feather" icon="icon-credit-card">
            Ödeme Ekranı
          </vs-button>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="info-row px-3 payment-screen-meta" vs-justify="space-between" v-if="activePersonel">
          <vs-col vs-w="6" vs-type="flex" vs-justify="flex-start" vs-align="center" class="payment-meta-staff">
            <p class="text-primary bold payment-meta-label">
              Personal Adı :
            </p>
            <p class="text-primary ml-2 weight-500 payment-meta-value">
              {{ activePersonel ? activePersonel.name : "" }}
            </p>
          </vs-col>
          <vs-col vs-w="6" vs-type="flex" vs-justify="flex-end" vs-align="center" class="payment-meta-datetime">
            <p class="text-primary weight-600 mr-3 payment-meta-date">{{ currentDate }}</p>
            <p class="text-primary weight-500 payment-meta-time">{{ currentTime }}</p>
          </vs-col>
        </vs-row>
        <div id="data-list-thumb-view" class="data-list-container">
          <div class="payment-table-panel">
          <vs-table multiple :data="paymentGroups" v-model="selectedPaymentGroup" id="orderListTable">
            <div slot="header" class="w-full flex flex-wrap items-center flex-grow justify-between">
            </div>
            <template slot="thead">
              <vs-th class="payment-th-product">
                <p class="column-head-text">Ürün</p>
              </vs-th>
              <vs-th class="payment-th-price">
                <p class="column-head-text">Fiyat</p>
              </vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr" class="order-list-table-tr"
                     :class="{'bg-secondary2': indextr % 2 != 0}">
                <vs-td class="payment-td-product">
                  <vs-row vs-type="block" vs-w="12" v-for="entry in tr.entries" :key="entry.id">
                    <p class="text-center tr-text text-primary payment-product-name">
                      {{ entry.productName + (entry.quantity > 1 ? ' - x' + entry.quantity : '') }}</p>
                    <div
                      v-if="getEntryExtraLines(entry).length"
                      class="payment-entry-extras"
                    >
                      <p
                        v-for="(line, exIdx) in getEntryExtraLines(entry)"
                        :key="'pex-' + (entry.id || entry.rowId || '') + '-' + exIdx"
                        class="payment-entry-extra-line text-center"
                      >
                        {{ line }}
                      </p>
                    </div>
                    <p v-show="rawmaterial.selected && rawmaterial.isDefault == false"
                       v-for="(rawmaterial, rawMaterialIndex) in entry.recipe.steps" :key="rawMaterialIndex"
                       class="text-center tr-text-child text-primary payment-entry-recipe-line">
                      {{ rawmaterial.name }}
                    </p>
                  </vs-row>
                </vs-td>
                <vs-td class="payment-td-price">
                  <vx-tooltip v-if="tr.entries.some(x=> x.originPrice != x.price && x.originPrice)"
                              :text="getTotalGift(tr) + 'İndirim'" position="top">
                    <feather-icon icon='GiftIcon' svgClasses='h-5 w-5' class='text-success'/>
                  </vx-tooltip>
                  <span v-if="tr.payedPrice > 0 && tr.payedPrice != tr.totalPrice"
                        class="text-center text-primary tr-text w-full line-through">
                  {{ $toCurrency(tr.totalPrice) }}
                </span>
                  <p class="text-center text-primary tr-text w-full"
                     :class="{'payed-row': tr.totalPrice-tr.payedPrice == 0}">{{
                      (tr.totalPrice - tr.payedPrice != 0 ? $toCurrency(tr.totalPrice -
                        tr.payedPrice) : "Ödendi")
                    }} ₺</p>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          </div>
          <div class="payment-footer-stack">
          <div class="payment-summary-sticky">
          <vs-row vs-type="flex" vs-w="12" class="payment-summary-bar px-3">
            <vs-col vs-type="flex" vs-w="5" vs-justify="flex-start" class="payment-summary-bar-col">
              <div class="w-auto flex align-center">
                <div class="d-flex align-center pointer">
                  <p class="price-label bold mr-3">
                    Toplam Tutar:
                  </p>
                  <p class="price bold mr-3">
                    {{ $toCurrency(totalPrice) }}
                  </p>
                  <vs-button v-show="orderPayments != null && orderPayments.length > 0"
                             @blur="showPaymentHistory = false"
                             @click="showPaymentHistory=!showPaymentHistory" icon-pack="feather"
                             icon="icon-more-horizontal" radius
                             size="small" color="transparent" class="sale-box-shadow bg-secondary text-primary"/>
                </div>
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-w="2" vs-justify="center" class="payment-summary-bar-col payment-summary-bar-print">
              <div class="payment-print-toggle">
              <vs-checkbox class="bold text-primary payment-print-checkbox" v-model="isPrintOrders">Fiş Yazdırılsın</vs-checkbox>
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-w="5" vs-justify="flex-end" class="payment-summary-bar-col">
              <div class="flex justify-flex-end align-center">
                <p class="price-label bold mr-5">
                  Seçilen Tutar:
                </p>
                <p class="price bold">
                  {{ $toCurrency(selectedGroupsPrice) }}
                </p>
              </div>
            </vs-col>
          </vs-row>
          </div>
          <vs-row vs-type="flex" vs-w="12" class="order-list-bottom-row payment-actions-toolbar">
            <vs-col vs-type="block" vs-w="2" class="order-list-bottom-side">
              <transition name="fade">
                <div v-show="showPaymentHistory && orderPayments.length > 0"
                     class="payment-history w-full text-primary">
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-row class="payment-log bold" vs-type="flex" vs-w="12" vs-justify="center"
                            v-for="log in orderPayments" :key="log.id">
                      {{ $toCurrency(log.price) }} {{ log.paymentMethod.name }}
                    </vs-row>
                  </vs-row>
                </div>
              </transition>
            </vs-col>
            <vs-col vs-type="block" vs-w="8" class="order-list-bottom-main">
              <vs-row vs-type="flex" vs-w="12">
                <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="mt-3 payment-actions-host">
                  <select-payment-type ref="selectPaymentType" :dontCloseCalc="false" :totalPrice="totalPrice"
                                       :currentDate="currentDate" :currentTime="currentTime"/>
                </vs-row>
                <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="mt-1 py-2 payment-main-actions-row">
                  <vs-col vs-type="flex" vs-w="3" vs-justify="flex-end" class="mr-2 payment-main-actions-col">
                    <vs-button @click="closePaymentPopup" :disabled="isPaymentStarted || isPosSettlementInProgress" size="large" color="primary" type="gradient"
                               class="bold half-friendly-border sale-box-shadow w-64 order-list-wide-btn pay-toolbar-btn pay-toolbar-btn--ghost" icon-pack="feather"
                               icon="icon-arrow-left">
                      Geri
                      Dön
                    </vs-button>
                  </vs-col>
                  <vs-col vs-type="flex" vs-w="3" vs-justify="flex-start" class="ml-2 mr-2 payment-main-actions-col">
                    <vs-button v-if="!isCommitable&&isPosEnabled" color="transparent"
                               class="text-white bg-success p-1 bold sale-box-shadow w-64 text-medium-small order-list-wide-btn pay-toolbar-btn pay-toolbar-btn--primary"
                               @click="doPay(selectedPaymentGroup.length>0?selectedGroupsPrice: totalPrice,false)">
                      {{ selectedPaymentMethod && (selectedPaymentMethod.name || selectedPaymentMethod.Name) ? (selectedPaymentMethod.name || selectedPaymentMethod.Name) : 'Kredi Kartı' }} ile Öde
                      {{ selectedPaymentGroup.length > 0 ? $toCurrency(selectedGroupsPrice) : $toCurrency(totalPrice) }}
                    </vs-button>
                    <vs-button v-if="!isCommitable&&!isPosEnabled" color="transparent"
                               class="text-white bg-success p-1 bold sale-box-shadow w-64 text-medium-small order-list-wide-btn pay-toolbar-btn pay-toolbar-btn--primary"
                               @click="doPayWithoutPos(selectedPaymentGroup.length>0?selectedGroupsPrice: totalPrice,false)">
                      {{ selectedPaymentMethod && (selectedPaymentMethod.name || selectedPaymentMethod.Name) ? (selectedPaymentMethod.name || selectedPaymentMethod.Name) : 'Nakit/Kredi Kartı' }} ile Öde
                      {{ selectedPaymentGroup.length > 0 ? $toCurrency(selectedGroupsPrice) : $toCurrency(totalPrice) }}
                    </vs-button>
                    <transition name="slide-fade">
                      <vs-button :disabled="isTransaction" v-if="isCommitable" size="large" color="transparent"
                                 @click="createCommitModel"
                                 class="glowing w-64 text-white bg-success3 bold sale-box-shadow order-list-wide-btn pay-toolbar-btn pay-toolbar-btn--success">
                        Sepeti Bitir
                      </vs-button>
                    </transition>
                  </vs-col>
                </vs-row>
              </vs-row>
            </vs-col>
            <vs-col vs-type="flex" vs-w="2" vs-justify="flex-end" vs-align="center" class="order-list-bottom-side order-list-calc-col">
              <div class="bg-secondary calc-button sale-box-shadow payment-calc-fab" @click="totalPrice != 0 ? seperatePayment() : null">
                <vs-button :disabled="totalPrice == 0" color="transparent" type="flat"
                           class="small-icon text-primary p-0"
                           icon-pack="feather" icon="icon-chevron-left"/>
                <vs-button :disabled="totalPrice == 0" color="transparent" type="flat"
                           class="large-icon text-primary p-0"
                           icon-pack="feather" icon="icon-percent"/>
              </div>
            </vs-col>
          </vs-row>
          </div>
        </div>
        </div>
        <discount ref="discount" @appendDiscount="appendDiscount"
                  :priceToDiscount="selectedPaymentGroup.length>0?selectedGroupsPrice: totalPrice"
                  :currentDate="currentDate"
                  :currentTime="currentTime"/>
      </vs-popup>

    </vs-row>
    <!-- Fiş: popup kapalıyken DOM'dan silinmesin; master ile aynı print-js akışı (ref + $el) -->
    <printer2
      ref="printer2"
      class="selfservice-printer2-offscreen"
      :orderEntries="orderBillEntries"
      :totalPrice="totalOriginPrice"
      :totalDiscountPrice="totalDiscountPrice"
      :currentDateTime="currentDate + ' ' + currentTime"
      :activePersonal="activePersonel ? activePersonel.name : ''"
    />
  </div>

</template>

<script>
/* eslint-disable no-unused-vars */
import Discount from "./Discount";
import Calc from "./Calc.vue";
import _ from "lodash";
import CustomLoadingComponent from "@/views/pages/customLoadingComponent";
import QrReader from "./QrReader.vue";
import {

  uuid
} from "vue-uuid";
import {
  completePayment,
  validateCartPrice
} from "@/api/SelfService";
import {
  logSelfServiceManualEvent,
  SelfServiceEventType,
  summarizeCartEntry
} from "@/utils/selfServiceSessionTelemetry";
import { buildOrderBillEntriesFromCartEntries } from "@/utils/selfServicePrintBill";
import { roundTry2 } from "@/utils/moneyTry";
import SelectPaymentType from "./SelectPaymentType.vue";
import {
  FindAvailableCampaigns
} from "@/api/Campaign.js";
import {getPosSettings} from "@/api/AppSettings";
import Printer2 from "./Printer2.vue";

/** POS "fiş basıyor / meşgul" cevabında otomatik yeniden deneme (canlı teşhis: 19-21.10'da 74 vaka). */
const POS_BUSY_MAX_RETRIES = 3;
const POS_BUSY_RETRY_DELAY_MS = 4000;
const POS_BUSY_MESSAGE_RE = /slip yazma|meşgul/i;
/** Sonucu belirsiz POS ödemesinden sonra bu süre boyunca otomatik yeniden deneme yapılmaz. */
const POS_UNKNOWN_BLOCK_MS = 10 * 60 * 1000;
const LAST_UNKNOWN_POS_KEY = "brew_last_unknown_pos_at";

export default {
  props: {
    currentTime: {
      type: String,
      required: true
    },
    currentDate: {
      type: String,
      required: true
    }
  },
  components: {
    CustomLoadingComponent,
    Calc,
    SelectPaymentType,
    Printer2,
    Discount,
    QrReader
  },
  data() {
    return {
      cloneCurrentCart: [],
      selectedGift: null,
      isPosEnabled: false,
      isPrintOrders: true,
      orderBillEntries: [],
      isTransaction: false,
      showPaymentHistory: false,
      isCommitable: false,
      isPaymentStarted:false,
      selectedPaymentGroup: [],
      isActive: false,
      orderPayments: [],
      paymentGroups: [],
      separatePaymentPrice: 0,
      paymentDiscount: {},
      discounts: [],
      ids: [],
      isPieced:false,
      posType:0,
      isRestoring: false,
      // POS'a ödeme isteği gönderildiği andan (askıda/CheckPendingSale döngüsü dahil) kesin
      // sonuca (başarı/başarısızlık/timeout) kadar true — bu süre boyunca "Geri Dön" kilitli
      // tutulur. isPaymentStarted'dan farkı: o sadece POS BAŞARIYI onayladıktan sonra true olur,
      // bekleme sırasında kasiyerin ekranı kapatıp yarış durumuna yol açmasını engellemez.
      isPosSettlementInProgress: false
    };
  },
  watch: {
    selectedPaymentGroup(newVal, oldVal) {
      if (newVal.length > 0) {
        let lastItem = newVal[newVal.length - 1];
        if (lastItem.totalPrice == lastItem.payedPrice) {
          this.selectedPaymentGroup = oldVal;
        }
      }
    },
    isActive: function (val) {
      if (val) {
        if (!this.isRestoring) {
          this.initValues();
          this.initGifts();
        }
        const sessionPaymentMethods = this.$store.getters["selfservice/getPaymentMethods"];
        if (sessionPaymentMethods && sessionPaymentMethods.length > 0) {
          const creditCardMethod = sessionPaymentMethods.find(m => m.id == process.env.VUE_APP_CREDIT_PAYMENT_ID);
          if (creditCardMethod) {
            this.$store.dispatch("selfservice/setSelectedPaymentMethod", creditCardMethod);
          } else {
            this.$store.dispatch("selfservice/setSelectedPaymentMethod", sessionPaymentMethods[0]);
          }
        }
      } else {
        this.selectedPaymentGroup = [];
        this.paymentGroups = [];
        this.orderPayments = [];
      }
      this.syncSession();
    },
    cloneCurrentCart: {
      deep: true,
      handler() { this.syncSession(); }
    },
    paymentGroups: {
      deep: true,
      handler() { this.syncSession(); }
    },
    orderPayments: {
      deep: true,
      handler() { this.syncSession(); }
    },
    discounts: {
      deep: true,
      handler() { this.syncSession(); }
    },
    isPaymentStarted(val) {
      this.syncSession();
    },
    isPieced(val) {
      this.syncSession();
    },
    totalPrice: function (val) {
      if (val == 0 && this.isActive == true) {
        this.isCommitable = true;
        this.createCommitModel();
      } else {
        this.isCommitable = false;
      }
    },
    selectedPaymentMethod(val) {
      if (val && val.id == 4) this.isActiveDiscount = true;
    },

  },
  computed: {
    isLoading: {
      get() {
        return this.$store.getters["selfservice/getIsLoading"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsLoading", val);
      },
    },
    isCakeQuestioned: {
      get() {
        return this.$store.getters["selfservice/getCakeQuestioned"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setCakeQuestioned", val);
      }
    },
    totalDiscountPrice() {
      const vm = this;
      let paymentDiscounts = this.orderPayments.reduce(function (total, num) {
        if (num.paymentMethod.id == 4 && num.paymentMethod.name == "İndirim")
          return total + num.price;
        else return total + 0;
      }, 0);
      let campaignDiscounts = this.paymentGroups.reduce(function (total, num) {
        let totalEntries = num.entries.reduce(function (entriesTotal, entryDiscount) {
          return entriesTotal + vm.roundTry2(entryDiscount.originPrice - entryDiscount.price);
        }, 0);
        return total + totalEntries;
      }, 0);
      return paymentDiscounts + campaignDiscounts;
    },
    isActiveDiscount: {
      get() {
        return this.$refs.discount.isActive;
      },
      set(val) {
        this.$refs.discount.isActive = val;
      }
    },
    selectedPaymentMethod: {
      get() {
        return this.$store.getters["selfservice/getSelectedPaymentMethod"];
      },
      set(val) {
        if (val)
          this.$store.dispatch("selfservice/setSelectedPaymentMethod", val);
      }
    },
    paymentMethods: function () {
      return this.$store.getters["selfservice/getPaymentMethods"];
    },
    isReset: {
      get() {
        return this.$store.getters["selfservice/getToIsReset"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsReset", val);
      }
    },
    totalOriginPrice: function () {
      return this.calculateTotalOriginPrice(this.paymentGroups);
    },
    totalPrice: function () {
      return this.calculateSelectedRemainingPrice(this.paymentGroups);
    },
    selectedGroupsPrice: function () {
      return this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
    },
    currentCart: {
      get() {
        return this.$store.getters["selfservice/getCurrentCart"];
      },
      set(payload) {
        this.$store.dispatch("selfService/setCurrentCartWithCampaign", payload);
      }
    },
    activePersonel: function () {
      return this.$store.getters["selfservice/getActivePersonal"];
    },
    toggleCalc: {
      get() {
        return this.$refs.calculatorPage.isActive;
      },
      set(val) {
        this.$refs.calculatorPage.isActive = val;
      }
    },
  },

  methods: {
    /** TL kuruş hizası — `@/utils/moneyTry` ile backend/ödeme satırlarıyla aynı kaynak. */
    roundTry2,
    /**
     * Harici POS köprüsü (`complete-sale`) satır doğrulaması: miktar × birim ≈ brüt.
     * Sepet quantity > 1 iken `price` alanına satır kalanını yazıp quantity’yi korumak,
     * köprü tarafında birim fiyat sanılırsa 0,01 sapmaya yol açıyordu.
     * Tahsil satırında quantity=1 ve price=satır kalan tutarı kullanılır; çok satırda toplam `payedAmount` ile reconcile edilir.
     */
    buildPosSaleItemsForCompleteSale(selectedPaymentGroup, payedAmount, isPieced) {
      const r = roundTry2;
      const target = r(payedAmount);
      if (isPieced) {
        return [
          {
            name: "İçecek",
            price: target,
            quantity: 1,
            kdv: 10,
          },
        ];
      }
      const rows = [];
      selectedPaymentGroup.forEach((selectProduct) => {
        if (selectProduct.payedPrice === selectProduct.totalPrice) return;
        const lineGross = r(selectProduct.totalPrice - selectProduct.payedPrice);
        if (lineGross <= 0) return;
        const entry = selectProduct.entries[0];
        const saleModel = {
          name: entry.productName,
          quantity: 1,
          kdv: 10,
          price: lineGross,
        };
        if (entry.categories && entry.categories.length > 0) {
          saleModel.id = entry.categories[0].id;
        } else {
          saleModel.id = entry.categoryId;
        }
        if (saleModel.id === 16) saleModel.id = 1;
        rows.push(saleModel);
      });
      let sum = rows.reduce((s, row) => s + row.price, 0);
      sum = r(sum);
      const drift = r(target - sum);
      if (rows.length > 0 && drift !== 0) {
        const last = rows[rows.length - 1];
        last.price = r(last.price + drift);
      }
      if (rows.length === 0 && target > 0) {
        return [
          {
            name: "İçecek",
            price: target,
            quantity: 1,
            kdv: 10,
          },
        ];
      }
      return rows;
    },
    /** Backend OrderManager: CartEntries.Sum(Price) ile TotalPrice aynı olmalı */
    totalPriceFromCartEntries(entries) {
      if (!entries || !entries.length) return 0;
      const line = (e) => {
        const p = e.price != null ? e.price : e.Price;
        return Number(p) || 0;
      };
      const sum = entries.reduce((s, e) => s + line(e), 0);
      return this.roundTry2(sum);
    },
    commitQrCode(customer) {
      console.log(customer);
      console.log('çalıştı qr');
        this.$store.dispatch("selfservice/setCurrentCartCustomer", customer);
        this.cloneCurrentCart = _.cloneDeep(this.currentCart);
        console.log(this.cloneCurrentCart);
        this.initGifts();
      },
    commitPartnerQr(partner) {
      this.$store.dispatch("selfservice/setCurrentCartPartnerQr", partner);
      this.cloneCurrentCart = _.cloneDeep(this.currentCart);
      this.initGifts();
      this.$vs.notify({
        color: "success",
        title: "Partner QR",
        text: (partner.name || "Partner kampanyası") + " uygulanıyor..."
      });
    },
    getTotalGift(row) {
      let totalGift = row.entries.reduce(function (total, num) {
        if (num.originPrice - num.price > 0)
          return total + (num.originPrice - num.price);
        else return total + 0;
      }, 0);
      return this.$toCurrency(totalGift);
    },
    initValues() {
      this.selectedGift = null;
      this.orderPayments = [];
      this.paymentGroups = [];
      this.selectedPaymentGroup = [];
      this.cloneCurrentCart = this.currentCart ? _.cloneDeep(this.currentCart) : null;
      this.generatePaymentGroups();
      this.isTransaction = false;
      this.isPrintOrders = true;
      this.isPaymentStarted = false;
    },
    generatePaymentGroups() {
      this.paymentGroups.length = 0;
      if (!this.cloneCurrentCart || !this.cloneCurrentCart.cartEntries) return;
      this.cloneCurrentCart.cartEntries.forEach((entry) => {
        let tempPaymentGroup = {
          rowIndex: uuid.v1(),
          entries: [],
          totalPrice: 0,
          payedPrice: 0,
          status: "Kalan"
        };
        tempPaymentGroup.rowIndex = uuid.v1();
        tempPaymentGroup.entries.push(entry);
        tempPaymentGroup.totalPrice = this.roundTry2(entry.price);
        tempPaymentGroup.payedPrice = 0;
        tempPaymentGroup.status = "Kalan";

        this.paymentGroups.push(_.cloneDeep(tempPaymentGroup));
      });
      this.reCalculatePaymentGroup();
    },
    initGifts() {
      let productIds = [];
      let categoryIds = [];
      let totalPrice = 0;
      if (this.cloneCurrentCart && (this.cloneCurrentCart.customer || this.cloneCurrentCart.partnerQr)) {
        let cart = this.cloneCurrentCart;
        cart.cartEntries.forEach(x => {
          if (x.categories && x.categories.length > 0) {
            x.categoryId = x.categories[0].id;
          }
        });
        let payments = this.orderPayments;
        const userInfo = JSON.parse(localStorage.getItem("userInfo"));
        let orderModel = {
          id: cart.id,
          customerId: cart.customer ? cart.customer.id : null,
          qrCode: cart.partnerQr ? cart.partnerQr.qrCode : (cart.customer ? cart.customer.giftQrCode : null),
          campaignQrCode: cart.customer ? cart.customer.campaignQrCode : null,
          partnerCampaignQrId: cart.partnerQr ? cart.partnerQr.partnerCampaignQrId : null,
          totalPrice: cart.totalPrice,
          active: cart.active,
          cartEntries: [...cart.cartEntries],
          branchName: userInfo && userInfo.branch ? userInfo.branch.name : "",
          paymentInformations: [...payments],
          userName: this.activePersonel ? this.activePersonel.name : "",
          userId: this.activePersonel ? Number(this.activePersonel.id) : null,
        };
        FindAvailableCampaigns(orderModel).then(res => {
          if (res && res.status == 200) {
            if (res.data.isValid) {
              const newEntries = res.data.newEntries || res.data.NewEntries;
              if (newEntries != null) {
                this.cloneCurrentCart.cartEntries = newEntries;
              }
              if (res.data.customerGiftId != null) this.cloneCurrentCart.customerGiftId = res.data.customerGiftId;
              else if (res.data.campaignGiftId != null) this.cloneCurrentCart.campaignGiftId = res.data
                .campaignGiftId;
              /* PlaceOrder: sum(line.Price) == TotalPrice; kampanya newEntries sonrası eski totalPrice kalmamalı */
              this.cloneCurrentCart.totalPrice = this.totalPriceFromCartEntries(this.cloneCurrentCart.cartEntries);
              this.generatePaymentGroups();
            } else if (cart.partnerQr) {
              this.$vs.notify({
                color: "warning",
                title: "Partner QR",
                text: "Kampanya bu şube veya sepet için geçerli değil."
              });
            }
          } else {
            this.$fire({
              title: "Hata : " + res.status,
              text: "Kampanyalara Erişilemedi !",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Kampanyalara Erişilemedi !"
            });
          }
        }).catch(() => {
          this.$fire({
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
              type: "error"
            });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      }
    },
    appendDiscount(discountObj) {
      const discountedItems = [];
      let totalQuantity = 0;
      let totalPrice = 0;

      const targetGroups = this.selectedPaymentGroup.length > 0
        ? this.selectedPaymentGroup
        : this.paymentGroups;

      targetGroups.forEach(group => {
        group.entries.forEach(entry => {
          discountedItems.push({
            productName: entry.productName,
            quantity: entry.quantity,
            price: entry.price
          });
          totalQuantity += entry.quantity;
          totalPrice += entry.price;
        });
      });

      logSelfServiceManualEvent(SelfServiceEventType.DiscountApplied, {
        value: discountObj.value,
        unit: discountObj.unit,
        description: discountObj.description,
        discountDescription: discountObj.discountDescription,
        priceToDiscount: discountObj.priceToDiscount,
        payedPrice: discountObj.payedPrice,
        discountedItems: discountedItems,
        totalQuantity: totalQuantity,
        totalPrice: totalPrice
      });
      this.paymentDiscount = {
        paymentMethod: this.selectedPaymentMethod,
        value: discountObj.value,
        description: discountObj.description,
        unit: discountObj.unit,
        selectedPaymentGroup: this.selectedPaymentGroup.map(r => r.entries).map(j => j[0].id),
        payedPrice: discountObj.payedPrice,
        discountDescription : discountObj.discountDescription
      }
      if (this.isPosEnabled) {
        this.doPay(discountObj.priceToDiscount, true);

      } else {
        this.doPayWithoutPos(discountObj.priceToDiscount, true);
      }
      this.discounts.push(this.paymentDiscount)
      this.paymentDiscount = {}
    },
    returnSelectedExtraVariant(extra) {
      if (!extra || !extra.variants || !extra.variants.length) {
        return null;
      }
      const returnObj = [];
      extra.variants.forEach((x) => {
        if (x.quantity > 0) {
          returnObj.push("x" + x.quantity + " | " + x.name);
        }
      });
      return returnObj.length > 0 ? returnObj : null;
    },
    getEntryExtraLines(entry) {
      if (!entry || !entry.extras || !entry.extras.length) {
        return [];
      }
      const lines = [];
      entry.extras.forEach((extra) => {
        const variants = extra.variants || [];
        if (variants.length > 0) {
          const vLines = this.returnSelectedExtraVariant(extra);
          if (vLines) {
            vLines.forEach((l) => lines.push(l));
          }
        } else if (extra.quantity > 0) {
          lines.push("x" + extra.quantity + " | " + extra.name);
        }
      });
      return lines;
    },
    /** POS/köprü isteklerinde donmayı önlemek için — cihaz/köprü cevap vermezse istek belirli bir
     * süre sonra kendini iptal eder (AbortController), mevcut catch blokları hatayı normal şekilde işler. */
    fetchWithTimeout(url, options, timeoutMs = 30000) {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
      return fetch(url, { ...options, signal: controller.signal }).finally(() => clearTimeout(timeoutId));
    },
    /** Satış isteği (complete-sale / create) müşteri kartı okutup PIN girene kadar sürer; 30 sn bu
     * süreye yetmiyordu ve tarayıcı isteği keserken POS ödemeyi onaylıyordu. Köprü cihazı en fazla
     * ~100 sn bekler (HttpClient varsayılanı); bu üst sınır yalnızca köprü hiç cevap vermezse diye. */
    posSaleTimeoutMs() {
      return 180000;
    },
    posTelemetryBase(payedAmount) {
      const method = this.selectedPaymentMethod || {};
      return {
        amount: payedAmount,
        paymentMethodId: method.id,
        paymentMethodName: method.name || method.Name,
        cartId: this.cloneCurrentCart ? this.cloneCurrentCart.id : undefined,
        cartTotal: this.cloneCurrentCart && this.cloneCurrentCart.cartEntries
          ? this.totalPriceFromCartEntries(this.cloneCurrentCart.cartEntries)
          : undefined
      };
    },
    /** POS ödemesini sepete işler (paymentGroups + orderPayments) ve tam ödendiyse siparişi kapatır.
     * resultData null ise (kasiyer onaylı kurtarma) seçili ödeme yöntemi kullanılır. */
    recordPosPayment(payedAmount, isDiscount, resultData) {
      this.isPaymentStarted = true;
      let posStatusId = this.getPaymentMethodIdFromPosResponse(resultData, this.selectedPaymentMethod.id);

      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }
      let removeIndex = [];
      let tempGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: 0,
        payedPrice: payedAmount,
        status: "Kalan"
      };
      let vm = this;

      this.paymentGroups.forEach((item) => {
        tempGroup.rowIndex = uuid.v1();
        if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
          tempGroup.entries = tempGroup.entries.concat(item.entries);
          tempGroup.payedPrice = this.roundTry2(tempGroup.payedPrice + item.payedPrice);
          removeIndex.push(item.rowIndex);
        }
      });

      let removedPaymentGroup = [];
      this.paymentGroups.forEach((x, index) => {
        if (!removeIndex.some(rm => rm == x.rowIndex)) {
          removedPaymentGroup.push(vm.paymentGroups[index]);
        }
      });
      removedPaymentGroup.push(tempGroup);
      this.paymentGroups = removedPaymentGroup;

      this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
      this.selectedPaymentGroup = [];
      this.reCalculatePaymentGroup();

      let orderPayment = {
        id: uuid.v1(),
        paymentMethod: _.cloneDeep(this.selectedPaymentMethod),
        price: payedAmount,
        value: isDiscount ? this.paymentDiscount.value : null,
        unit: isDiscount ? this.paymentDiscount.unit : null,
        description: isDiscount ? this.paymentDiscount.description : null
      };

      // Dinamik ödeme türü eşleme (kredi kartından nakit fısı iptaline geçiş durumunda vs.)
      let actualMethod = this.paymentMethods.find(x => x.id === posStatusId || x.Name === posStatusId || x.name === posStatusId);
      if (actualMethod) {
        orderPayment.paymentMethod = _.cloneDeep(actualMethod);
      } else {
        orderPayment.paymentMethod.id = posStatusId;
      }

      if (resultData && resultData.financialDocuments && resultData.financialDocuments.length > 0) {
        orderPayment.financialDocument = resultData.financialDocuments[0];
        orderPayment.financialDocument.saleUid = resultData.saleUid;
        orderPayment.financialDocument.orderNo = resultData.orderNo;
      }

      this.orderPayments.push(orderPayment);
      this.toggleCalc = false;
      // Ödeme ekranı kasiyer tarafından (POS'un cevabı beklenirken) kapatılmış olsa bile
      // sipariş kapanmalı — bkz. commitIfFullyPaid yorumu.
      this.commitIfFullyPaid();
    },
    /** POS'tan kesin sonuç alınamadığında (zaman aşımı, köprü hatası, askıda kalan işlem) ödeme
     * POS'ta onaylanmış olabilir. Köprüde durum sorgulama ucu olmadığı için kasiyere POS ekranını/
     * fişini kontrol ettirip sorarız; tekrar çekim yapılıp müşteriden iki kez para alınmasını önler.
     * Kasiyer onayı teşhis günlüğüne ayrı bir olay olarak yazılır (denetim için). */
    isPosBusyMessage(message) {
      return POS_BUSY_MESSAGE_RE.test(String(message || ""));
    },
    /** Son 10 dk içinde sonucu belirsiz POS ödemesi olduysa otomatik yeniden deneme kapalı:
     * POS'un o an bastığı fiş, müşterinin aslında ödediği o işleme ait olabilir. */
    isPosAutoRetryAllowed() {
      let last = 0;
      try {
        last = Number(sessionStorage.getItem(LAST_UNKNOWN_POS_KEY) || 0);
      } catch (e) {
        last = 0;
      }
      return !(last && Date.now() - last < POS_UNKNOWN_BLOCK_MS);
    },
    async resolveUnknownPosResult(payedAmount, isDiscount, failure) {
      this.isLoading = false;
      try {
        sessionStorage.setItem(LAST_UNKNOWN_POS_KEY, String(Date.now()));
      } catch (e) {
        // sessionStorage yoksa yalnızca bu koruma devre dışı kalır
      }
      logSelfServiceManualEvent(SelfServiceEventType.PosSaleFailed, Object.assign(
        this.posTelemetryBase(payedAmount),
        { outcome: "unknown", askedCashier: true },
        failure
      ));
      const result = await this.$fire({
        title: "POS sonucu alınamadı",
        html:
          "<b>" + this.$toCurrency(payedAmount) + "</b> tutarındaki ödeme için POS cihazından cevap alınamadı.<br><br>" +
          "Lütfen <b>POS ekranını ve fişini kontrol edin</b>.<br>" +
          "POS'ta ödeme <b>ONAYLANDIYSA</b> \"Ödeme Alındı\" seçin — tekrar çekim yapmayın.<br>" +
          "Ödeme onaylanmadıysa \"Ödeme Alınmadı\" seçip tekrar deneyin.",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Ödeme Alındı",
        cancelButtonText: "Ödeme Alınmadı",
        confirmButtonColor: "#28c76f",
        cancelButtonColor: "#ea5455",
        allowOutsideClick: false,
        allowEscapeKey: false,
        reverseButtons: true
      });
      const confirmed = !!(result && result.value);
      logSelfServiceManualEvent(
        confirmed ? SelfServiceEventType.PosPaymentManuallyConfirmed : SelfServiceEventType.PosSaleFailed,
        Object.assign(this.posTelemetryBase(payedAmount), {
          outcome: confirmed ? "cashierConfirmedPaid" : "cashierConfirmedNotPaid",
          reason: failure && failure.reason
        })
      );
      if (confirmed) {
        this.recordPosPayment(payedAmount, isDiscount, null);
        this.$vs.notify({
          color: "success",
          title: "Ödeme kasiyer onayıyla kaydedildi",
          text: this.$toCurrency(payedAmount)
        });
      }
    },
    /** Ödeme ekranı kasiyer tarafından kapatılmış olsa bile (isActive=false), POS gerçekten tam
     * ödemeyi onayladıysa siparişi kapatır. totalPrice watcher'ındaki isActive şartına bağlı kalmadan
     * doğrudan çağrılır — ekranın açık kalıp kalmaması sipariş kapanmasını etkilememeli. */
    /** Backend ResponseModel hata mesajı (Errors[0].Message); ağ hatasında null. */
    serverErrorMessage(err) {
      const data = err && err.response && err.response.data;
      if (!data) return null;
      const errors = data.Errors || data.errors;
      if (errors && errors.length) {
        return errors[0].Message || errors[0].message || null;
      }
      return data.message || data.Message || null;
    },
    commitIfFullyPaid() {
      if (this.calculateSelectedRemainingPrice(this.paymentGroups) === 0) {
        this.isCommitable = true;
        this.createCommitModel();
      }
    },
    createCommitModel() {
      if (this.isTransaction == true) {
        return;
      }
      this.isTransaction = true;
      let cart = this.cloneCurrentCart;
      let payments = this.orderPayments;
      const totalPrice = this.totalPriceFromCartEntries(cart.cartEntries);
      cart.totalPrice = totalPrice;
      let orderModel = {
        id: cart.id,
        isNavigatedByQuestion: cart.isNavigatedByQuestion,
        customerId: cart.customer ? cart.customer.id : null,
        customerGiftId: cart.customerGiftId ? cart.customerGiftId : null,
        campaignGiftId: cart.campaignGiftId ? cart.campaignGiftId : null,
        qrCode: cart.partnerQr ? cart.partnerQr.qrCode : (cart.customer ? cart.customer.giftQrCode : null),
        partnerCampaignQrId: cart.partnerQr ? cart.partnerQr.partnerCampaignQrId : null,
        totalPrice,
        active: cart.active,
        cartEntries: [...cart.cartEntries],
        branchName: (JSON.parse(localStorage.getItem("userInfo")) || {}).branch ? (JSON.parse(localStorage.getItem("userInfo")).branch.name || "") : "",
        paymentInformations: [...payments],
        userName: this.activePersonel ? (this.activePersonel.name + " " + (this.activePersonel.surname || "")) : "",
        userId: this.activePersonel ? Number(this.activePersonel.id) : null,
        discounts: this.discounts
      };
      completePayment(orderModel).then(async result => {
        this.discounts = []
        if (result && result === true) {
          const totalEntryPrice = this.orderPayments.reduce(
            (a, b) => a + (b.price || 0),
            0
          );
          const paymentsCount = payments.length;
          this.orderBillEntries = buildOrderBillEntriesFromCartEntries(
            cart.cartEntries || []
          );
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.orderPayments = [];
              this.isReset = true;
              if (this.isPrintOrders && this.$refs.printer2) {
                this.$refs.printer2.printOrders();
              }
              this.$store.dispatch("selfservice/finalizeSuccessfulSelfServiceOrder");
              // Sipariş kapandı: oturumda "ödeme sürüyor" bayrağı kalırsa 45 sn PIN kilidi
              // (SelfService.resetIdleLockTimer) bir sonraki ödeme ekranı açılana kadar hep ertelenir.
              this.isPaymentStarted = false;
              this.isActive = false;
              this.isCakeQuestioned = false;
              this.isTransaction = false;
              this.$store.dispatch("selfservice/setLastBillId");
              this.$vs.notify({
                color: "success",
                title: totalEntryPrice.toFixed(2) + " Tutarında Sepet Tamamlandı !",
                text: paymentsCount + " Ödeme Gerçekleşti."
              });
            });
          });
        } else {
          const priceValidationErrors = await this.getPriceValidationErrors(cart.cartEntries);
          logSelfServiceManualEvent(SelfServiceEventType.OrderCloseFailed, {
            cartId: cart.id,
            totalPrice,
            paymentsCount: payments.length,
            paidTotal: payments.reduce((a, b) => a + (b.price || 0), 0),
            message: "Sunucu sonucu: " + JSON.stringify(result),
            cartEntries: (cart.cartEntries || []).map(summarizeCartEntry),
            priceValidationErrors
          });
          this.$fire({
            title: "Hata !",
            text: "Ürün Satışı Tamamlanamadı ! Ödeme kayıtlı; \"Tamamla\" ile tekrar deneyebilirsiniz.",
              type: "error"
            });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Ürün Satışı Tamamlanamadı !"
          });
          // this.initValues();
          this.isTransaction = false;
        }
      }).catch(async err => {
        const serverMessage = this.serverErrorMessage(err);
        const priceValidationErrors = await this.getPriceValidationErrors(cart.cartEntries);
        logSelfServiceManualEvent(SelfServiceEventType.OrderCloseFailed, {
          cartId: cart.id,
          totalPrice,
          paymentsCount: payments.length,
          paidTotal: payments.reduce((a, b) => a + (b.price || 0), 0),
          httpStatus: err && err.response ? err.response.status : undefined,
          message: serverMessage || (err && err.message),
          cartEntries: (cart.cartEntries || []).map(summarizeCartEntry),
          priceValidationErrors
        });
        // Ağ hatası değilse sunucunun gerçek mesajını göster (ör. "Fiyat Bilgisi Hatalı..."),
        // aksi halde kasiyer sunucu reddini bağlantı sorunu sanıyordu.
        const text = serverMessage
          ? "Sipariş kapatılamadı: " + serverMessage
          : "Sunucu Bağlantı Hatası !";
        this.$fire({
            title: "Hata !",
            text: text + " Ödeme kayıtlı; \"Tamamla\" ile tekrar deneyebilirsiniz.",
              type: "error"
            });
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text
        });
        // this.initValues();,
        this.isTransaction = false;
      });
      this.discounts=[];
      this.isPieced = false;
    },
    seperatePayment() {
      if (this.selectedPaymentGroup.length > 0) {
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
        this.toggleCalc = true;
      } else {
        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.paymentGroups);
        this.toggleCalc = true;
      }
    },
    checkPosDevice: async function () {
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      let branchId = userInfo.branch.id
      let axiosResponse = await getPosSettings(branchId);
      localStorage.setItem("posSettings", JSON.stringify(axiosResponse.data));
      this.isPosEnabled = axiosResponse.data.enable;
      this.posType = axiosResponse.data.posType;
    },
    setIsPieced:function(){
      this.isPieced = true
    },
    /** Backend’de kredi id 2 veya POS eşlemesi 4 olabiliyor; sadece 2 kontrol edilince complete-sale atlanıyordu. */
    isCreditPaymentMethod(paymentMethod) {
      if (!paymentMethod) return false;
      const id = paymentMethod.id;
      return (
        id == process.env.VUE_APP_CREDIT_PAYMENT_ID ||
        id == process.env.VUE_APP_POS_PAYMENT_CREDIT
      );
    },
    isCashPaymentMethod(paymentMethod) {
      if (!paymentMethod) return false;
      const id = paymentMethod.id;
      return (
        id == process.env.VUE_APP_CASH_PAYMENT_ID ||
        id == process.env.VUE_APP_POS_PAYMENT_CASH
      );
    },
    isFoodCardPaymentMethod(paymentMethod) {
      if (!paymentMethod) return false;
      const name = (paymentMethod.name || paymentMethod.Name || "").toLowerCase();
      return (
        name.includes("multinet") ||
        name.includes("sodexo") ||
        name.includes("ticket") ||
        name.includes("metropol") ||
        name.includes("setcard")
      );
    },
    posPaymentTypeForSelectedMethod() {
      if (this.isFoodCardPaymentMethod(this.selectedPaymentMethod)) {
        return parseInt(process.env.VUE_APP_POS_PAYMENT_CREDIT, 10);
      }
      return this.isCreditPaymentMethod(this.selectedPaymentMethod)
        ? parseInt(process.env.VUE_APP_POS_PAYMENT_CREDIT, 10)
        : parseInt(process.env.VUE_APP_POS_PAYMENT_CASH, 10);
    },
    getPaymentMethodIdFromPosResponse(resultData, defaultId) {
      let posStatusId = defaultId;
      if (resultData && resultData.addedPayments && Array.isArray(resultData.addedPayments)) {
        let addedPayment = resultData.addedPayments.find(p => p.statusId === 2);
        if (addedPayment) {
          let paymentTypeId = addedPayment.paymentTypeId;
          let mediatorId = addedPayment.paymentMediatorId;
          
          const isSelectedFoodCard = this.isFoodCardPaymentMethod(this.selectedPaymentMethod);
          if (paymentTypeId) {
            if (isSelectedFoodCard && (paymentTypeId === 2 || paymentTypeId === 3)) {
              // Yemek kartı seçili iken POS'tan genel kredi kartı (2) veya harici ödeme (3) döndüyse seçimi koru
            } else {
              posStatusId = paymentTypeId;
            }
          }
          
          if (addedPayment.isExternal) {
            let targetMethodName = "";
            
            // Standard PAVO Mediator ID / PaymentType ID mappings for External Payments:
            // 1/101 = Multinet
            // 2/102 = Sodexo
            // 3/103/13/26/113/126 = Ticket (Edenred / Ticket Gift)
            // 4/104 = Setcard
            // 5/105 = Metropol
            // 6/106 = TokenFlex
            let brandId = addedPayment.externalPayment ? (addedPayment.externalPayment.paymentProviderBrandId || addedPayment.externalPayment.PaymentProviderBrandId) : null;
            if (mediatorId === 1 || mediatorId === 101 || brandId === 6 || paymentTypeId === 1 || paymentTypeId === 101) {
              targetMethodName = "Multinet";
            } else if (mediatorId === 2 || mediatorId === 102 || brandId === 2 || paymentTypeId === 2 || paymentTypeId === 102) {
              targetMethodName = "Sodexo";
            } else if (
              mediatorId === 3 || mediatorId === 103 || mediatorId === 13 || mediatorId === 26 || mediatorId === 113 || mediatorId === 126 || brandId === 3 || brandId === 13 || brandId === 9 ||
              paymentTypeId === 103 || paymentTypeId === 13 || paymentTypeId === 26 || paymentTypeId === 113 || paymentTypeId === 126
            ) {
              targetMethodName = "Ticket";
            } else if (mediatorId === 4 || mediatorId === 104 || brandId === 4 || paymentTypeId === 4 || paymentTypeId === 104) {
              targetMethodName = "Setcard";
            } else if (mediatorId === 5 || mediatorId === 105 || brandId === 7 || paymentTypeId === 5 || paymentTypeId === 105) {
              targetMethodName = "Metropol";
            } else if (mediatorId === 6 || mediatorId === 106 || brandId === 6 || paymentTypeId === 6 || paymentTypeId === 106) {
              targetMethodName = "TokenFlex";
            }
            
            if (targetMethodName) {
              let matchingMethod = this.paymentMethods.find(m => 
                (m.Name && m.Name.toLowerCase().includes(targetMethodName.toLowerCase())) ||
                (m.name && m.name.toLowerCase().includes(targetMethodName.toLowerCase()))
              );
              if (matchingMethod) {
                posStatusId = matchingMethod.id;
              }
            }
          }
        }
      }
      return posStatusId;
    },
    /** POS ödemesi SONRASI sipariş kapatma başarısız olursa (place-order reddi/ağ hatası), aynı kontrolü
     * teşhis amaçlı tekrar çalıştırır; olası fiyat tutarsızlığını OrderCloseFailed kaydına ekler.
     * Asıl hata akışını etkilememesi için her durumda (hata dahil) boş/anlamlı bir liste döner, fırlatmaz. */
    async getPriceValidationErrors(cartEntries) {
      try {
        const res = await validateCartPrice({ cartEntries: cartEntries || [] });
        if (res && res.status === 200 && res.data && res.data.result === false) {
          return (res.data.errors || []).map(e => e.message).filter(Boolean);
        }
      } catch (e) {
        // yut; bu sadece teşhis zenginleştirmesi, asıl hata akışını etkilemesin
      }
      return [];
    },
    /** Ödeme/POS'a gönderilmeden ÖNCE sepeti kanonik fiyat listesine karşı denetler; tutarsızlıkta ödemeyi engeller. */
    async ensureCartPriceValid() {
      const cartEntries = (this.cloneCurrentCart && this.cloneCurrentCart.cartEntries) || [];
      if (cartEntries.length === 0) return true;
      try {
        const res = await validateCartPrice({ cartEntries });
        if (res && res.status === 200 && res.data && res.data.result === false) {
          const messages = (res.data.errors || []).map(e => e.message).filter(Boolean);
          logSelfServiceManualEvent(SelfServiceEventType.PriceValidationBlocked, {
            cartId: this.cloneCurrentCart ? this.cloneCurrentCart.id : undefined,
            cartEntries: cartEntries.map(summarizeCartEntry),
            errors: messages
          });
          this.$fire({
            title: "Fiyat Hatası !",
            text: "Sepette fiyat tutarsızlığı tespit edildi, ödeme başlatılamadı. İlgili ürünü sepetten çıkarıp tekrar ekleyin.\n" + messages.join("\n"),
            type: "error"
          });
          this.$vs.notify({
            color: "danger",
            title: "Ödeme Engellendi !",
            text: "Sepet fiyatı hatalı."
          });
          return false;
        }
        return true;
      } catch (e) {
        // Doğrulama isteği başarısız olursa (ağ vb.) ödemeyi engelleme; backend place-order'da aynı kontrolü zaten yapıyor.
        return true;
      }
    },
    doPayWithoutPos: async function (payedPrice,isDiscount) {
      if (!(await this.ensureCartPriceValid())) return;
      const payedAmount = this.roundTry2(payedPrice);
      if (this.selectedPaymentMethod.id == process.env.VUE_APP_WALLET_PAYMENT_ID) {
        console.log(payedPrice);
        console.log(isDiscount);
        this.openQrReader(payedAmount,isDiscount);
        return;
      }
      // POS açıkken SADECE ana Kredi Kartı (id: 2 veya 4) veya fiziksel yemek kartları (Multinet vb.) seçildiyse POS'a gönder; 
      // Diğer (id:3) altındaki cari, yemeksepeti, trendyol vb. gibi manuel kapatılması gereken yöntemler POS'suz tamamlanır
      const originId = this.selectedPaymentMethod.originPaymentMethodId;
      if (
        this.isPosEnabled &&
        (this.isCreditPaymentMethod(this.selectedPaymentMethod) || 
         (this.isFoodCardPaymentMethod(this.selectedPaymentMethod) && originId !== 3))
      ) {
        this.doPay(payedAmount, isDiscount);
        return;
      }
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }
      let removeIndex = [];
      let tempGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: 0,
        payedPrice: payedAmount,
        status: "Kalan"
      };
      let vm = this;
      this.paymentGroups.forEach((item) => {
        tempGroup.rowIndex = uuid.v1();
        if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
          tempGroup.entries = tempGroup.entries.concat(item.entries);
          tempGroup.payedPrice = this.roundTry2(tempGroup.payedPrice + item.payedPrice);
          removeIndex.push(item.rowIndex);
        }
      });

      let removedPaymentGroup = [];
      this.paymentGroups.forEach((x, index) => {
        if (!removeIndex.some(rm => rm == x.rowIndex)) {
          removedPaymentGroup.push(vm.paymentGroups[index]);
        }
      });
      removedPaymentGroup.push(tempGroup);
      this.paymentGroups = removedPaymentGroup;
      this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
      this.selectedPaymentGroup = [];
      this.reCalculatePaymentGroup();

      let orderPayment = {
        id: uuid.v1(),
        paymentMethod: this.selectedPaymentMethod,
        price: payedAmount,
        value: isDiscount ? this.paymentDiscount.value : null,
        unit: isDiscount ? this.paymentDiscount.unit : null,
        description: isDiscount ? this.paymentDiscount.description : null,
        discountDescription : isDiscount ? this.paymentDiscount.discountDescription : null,
      };
      this.orderPayments.push(orderPayment);
      this.isPaymentStarted = true;
      this.toggleCalc = false;
      this.commitIfFullyPaid();
    },
    doPay: async function (payedPrice, isDiscount) {
      if (!(await this.ensureCartPriceValid())) return;
      const payedAmount = this.roundTry2(payedPrice);
      if (this.posType == parseInt(process.env.VUE_APP_POS_GMP)) {
        this.doPayGmp(payedAmount, isDiscount);
        return;
      }
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }
      let removeIndex = [];
      let tempGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: 0,
        payedPrice: payedAmount,
        status: "Kalan"
      };
      let vm = this;
      this.paymentGroups.forEach((item) => {
        tempGroup.rowIndex = uuid.v1();
        if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
          tempGroup.entries = tempGroup.entries.concat(item.entries);
          // tempGroup.payedPrice = Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
          removeIndex.push(item.rowIndex);
        }
      });
      const posSaleItems = this.buildPosSaleItemsForCompleteSale(
        this.selectedPaymentGroup,
        payedAmount,
        this.isPieced === true
      );
      this.isLoading = true;
      if (isDiscount) {
        this.isLoading = false;
        if (this.selectedPaymentGroup.length == 0) {
          this.selectedPaymentGroup = this.paymentGroups;
        }
        let removeIndex = [];
        let tempGroup = {
          rowIndex: uuid.v1(),
          entries: [],
          totalPrice: 0,
          payedPrice: payedAmount,
          status: "Kalan"
        };
        let vm = this;

        this.paymentGroups.forEach((item) => {
          tempGroup.rowIndex = uuid.v1();
          if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
            tempGroup.entries = tempGroup.entries.concat(item.entries);
            tempGroup.payedPrice = this.roundTry2(tempGroup.payedPrice + item.payedPrice);
            removeIndex.push(item.rowIndex);
          }
        });

        let removedPaymentGroup = [];

        this.paymentGroups.forEach((x, index) => {
          if (!removeIndex.some(rm => rm == x.rowIndex)) {
            removedPaymentGroup.push(vm.paymentGroups[index]);
          }
        });
        removedPaymentGroup.push(tempGroup);

        this.paymentGroups = removedPaymentGroup;

        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
        this.selectedPaymentGroup = [];

        this.reCalculatePaymentGroup();

        let orderPayment = {
          id: uuid.v1(),
          paymentMethod: this.selectedPaymentMethod,
          price: payedAmount,
          value: isDiscount ? this.paymentDiscount.value : null,
          unit: isDiscount ? this.paymentDiscount.unit : null,
          description: isDiscount ? this.paymentDiscount.description : null,
          discountDescription : isDiscount ? this.paymentDiscount.discountDescription : null,
        };
        this.orderPayments.push(orderPayment);
        // posTransactionId:"" // successden dönen pos fiş id orderpaymentin içine
        this.toggleCalc = false;
        this.commitIfFullyPaid();
      } else {
        const originId = this.selectedPaymentMethod.originPaymentMethodId;
        if (
          !this.isCashPaymentMethod(this.selectedPaymentMethod) &&
          !this.isCreditPaymentMethod(this.selectedPaymentMethod) &&
          !(this.isFoodCardPaymentMethod(this.selectedPaymentMethod) && originId !== 3)
        ) {
          this.doPayWithoutPos(payedAmount,isDiscount);
          this.isLoading = false;
          return;
        }

        this.isPosSettlementInProgress = true;
        const posStartedAt = Date.now();
        const posElapsedMs = () => Date.now() - posStartedAt;
        try {
        let data = null;
        let fetchFailed = false;
        // POS "fiş basıyor / meşgul" derse ödeme hiç başlamamıştır; birkaç saniye sonra otomatik
        // tekrar denenir. Ancak bu oturumda son 10 dk içinde sonucu belirsiz bir ödeme olduysa
        // basılan fiş o ödemeye ait olabilir (müşteri ödemiş olabilir) — o zaman tekrar denenmez.
        const autoRetryAllowed = this.isPosAutoRetryAllowed();
        let autoRetryCount = 0;

        for (;;) {
          data = null;
          fetchFailed = false;

          logSelfServiceManualEvent(SelfServiceEventType.PosSaleRequested, Object.assign(
            this.posTelemetryBase(payedAmount),
            { bridge: "complete-sale", posPaymentType: this.posPaymentTypeForSelectedMethod(), itemCount: posSaleItems.length },
            autoRetryCount > 0 ? { retryAttempt: autoRetryCount } : {}
          ));

          try {
            const response = await this.fetchWithTimeout(process.env.VUE_APP_POS_API + "complete-sale", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                PaymentType: this.posPaymentTypeForSelectedMethod(),
                SaleItems: posSaleItems,
              }),
            }, this.posSaleTimeoutMs());

            if (!response.ok) {
               throw new Error(`HTTP Hata: ${response.status}`);
            }
            data = await response.json();
          } catch (err) {
            fetchFailed = true;
            // İstek POS'a ulaşmış olabilir: sonuç bilinmiyor → kasiyere POS'u kontrol ettir.
            await this.resolveUnknownPosResult(payedAmount, isDiscount, {
              reason: err && err.name === "AbortError" ? "timeout" : (err && err.message && err.message.indexOf("HTTP") === 0 ? "bridgeHttpError" : "network"),
              message: err && err.message,
              durationMs: posElapsedMs()
            });
          }

          const busy = !fetchFailed && data && data.hasError == true && this.isPosBusyMessage(data.message);
          if (busy && autoRetryAllowed && autoRetryCount < POS_BUSY_MAX_RETRIES) {
            autoRetryCount++;
            logSelfServiceManualEvent(SelfServiceEventType.PosSaleFailed, Object.assign(
              this.posTelemetryBase(payedAmount),
              { outcome: "busyAutoRetry", message: data.message, autoRetry: autoRetryCount, durationMs: posElapsedMs() }
            ));
            this.$vs.notify({
              color: "warning",
              title: "POS meşgul / fiş basıyor",
              text: `${POS_BUSY_RETRY_DELAY_MS / 1000} sn sonra otomatik tekrar deneniyor (${autoRetryCount}/${POS_BUSY_MAX_RETRIES})`,
              time: POS_BUSY_RETRY_DELAY_MS
            });
            await new Promise(r => setTimeout(r, POS_BUSY_RETRY_DELAY_MS));
            continue;
          }
          break;
        }

        if (!fetchFailed && data) {
          this.isLoading = false;
          if (data.hasError == true) {
            const busyBlocked = this.isPosBusyMessage(data.message) && !autoRetryAllowed;
            logSelfServiceManualEvent(SelfServiceEventType.PosSaleFailed, Object.assign(
              this.posTelemetryBase(payedAmount),
              { outcome: "hasError", message: data.message, durationMs: posElapsedMs() },
              autoRetryCount > 0 ? { autoRetry: autoRetryCount } : {},
              busyBlocked ? { autoRetryBlocked: true } : {}
            ));
            const text = busyBlocked
              ? data.message + " — DİKKAT: Az önce sonucu belirsiz bir ödeme oldu; basılan fiş o ödemeye ait olabilir. Tekrar denemeden önce POS fişini kontrol edin."
              : data.message;
            this.$vs.notify({
              color: "danger",
              title: "Hata",
              text
            });
            this.$fire({
              title: "İptal",
              text,
              type: "error"
            });
            return;
          }

          const successStatuses = [3, 4, 5, 6, 8, 9, 10, 18, 19, 20, 21, 22, 24];
          let isStrictSuccess = false;
          let wasPending = false;
          let pendingUnknown = false;
          let resultData = data.data || data;

          if (resultData && successStatuses.includes(resultData.statusId)) {
            isStrictSuccess = true;
          } else if (resultData && resultData.statusId === 23) {
            wasPending = true;
            this.$vs.notify({ color: "warning", title: "İşlem Askıda", text: "Ödeme durumu kontrol ediliyor. Lütfen bekleyiniz...", time: 5000 });
            let retryCount = 0;
            let isPendingResolved = false;

            while (retryCount < 10 && !isPendingResolved) {
              await new Promise(r => setTimeout(r, 3000));
              try {
                const checkRes = await this.fetchWithTimeout(process.env.VUE_APP_POS_API + "CheckPendingSale", {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    Sale: {
                      SaleNumber: resultData.saleNumber || resultData.orderNo || "",
                      OrderNo: resultData.orderNo || ""
                    }
                  })
                });

                if (checkRes.ok) {
                  const checkData = await checkRes.json();
                  const checkResultData = checkData.data || checkData;

                  if (checkResultData && (successStatuses.includes(checkResultData.statusId) || checkResultData.RemainingPaymentAmount === 0 || checkResultData.remainingPaymentAmount === 0)) {
                    isStrictSuccess = true;
                    isPendingResolved = true;
                    resultData = checkResultData;

                    try {
                      await this.fetchWithTimeout(process.env.VUE_APP_POS_API + "FinalizeSale", {
                        method: "POST",
                        headers: {
                          Accept: "application/json",
                          "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                          Sale: {
                            RefererApp: "Pickpos",
                            RefererAppVersion: "1.0.0",
                            SaleNumber: checkResultData.saleNumber || checkResultData.SaleNumber || resultData.saleNumber || resultData.orderNo || "",
                            OrderNo: checkResultData.orderNo || checkResultData.OrderNo || resultData.orderNo || ""
                          }
                        })
                      });
                    } catch (finalizeErr) {
                      console.error("FinalizeSale Hatası:", finalizeErr);
                    }
                  } else if (checkResultData && checkResultData.statusId !== 23) {
                    isPendingResolved = true;
                  }
                }
              } catch (e) {
                console.error("CheckPendingSale Hatası:", e);
              }
              retryCount++;
            }

            if (!isStrictSuccess) {
              try {
                await this.fetchWithTimeout(process.env.VUE_APP_POS_API + "AbandonSuspendedSale", {
                  method: "POST",
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    Sale: {
                      RefererApp: "Pickpos",
                      RefererAppVersion: "1.0.0",
                      SaleNumber: resultData.saleNumber || resultData.orderNo || "",
                      OrderNo: resultData.orderNo || ""
                    }
                  })
                });
              } catch (abandonErr) {
                console.error("AbandonSuspendedSale Hatası:", abandonErr);
              }

              if (!isPendingResolved) {
                // Köprü askıdaki işlemin sonucunu veremedi: POS'ta onaylanmış olabilir.
                pendingUnknown = true;
              } else {
                this.$vs.notify({ color: "danger", title: "Ödeme Alınamadı", text: "Ödeme işlemi başarısız oldu ve askıdaki kayıt iptal edildi." });
              }
            }
          }

          if (isStrictSuccess) {
            logSelfServiceManualEvent(SelfServiceEventType.PosSaleSucceeded, Object.assign(
              this.posTelemetryBase(payedAmount),
              {
                statusId: resultData && resultData.statusId,
                orderNo: resultData && resultData.orderNo,
                saleNumber: resultData && resultData.saleNumber,
                wasPending: wasPending,
                durationMs: posElapsedMs()
              }
            ));
            this.recordPosPayment(payedAmount, isDiscount, resultData);
          } else if (pendingUnknown) {
            await this.resolveUnknownPosResult(payedAmount, isDiscount, {
              reason: "pendingUnresolved",
              statusId: 23,
              orderNo: resultData && resultData.orderNo,
              durationMs: posElapsedMs()
            });
          } else {
            logSelfServiceManualEvent(SelfServiceEventType.PosSaleFailed, Object.assign(
              this.posTelemetryBase(payedAmount),
              {
                outcome: wasPending ? "pendingDeclined" : "declined",
                statusId: resultData && resultData.statusId,
                message: resultData && resultData.message,
                durationMs: posElapsedMs()
              }
            ));
            this.$fire({
              title: "İptal",
              text: resultData.message || "Ödeme iptal edildi veya başarısız oldu",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: resultData.message || "Ödeme İptal Edildi",
              text: ""
            });
          }
        }
        } finally {
          this.isPosSettlementInProgress = false;
        }
      }
    },
    reCalculatePaymentGroup: function () {
      this.paymentGroups.forEach((pgroup) => {
        let totalPrice = 0;
        pgroup.entries.forEach((entry) => {
          totalPrice += this.roundTry2(entry.price);
        });
        pgroup.totalPrice = this.roundTry2(totalPrice);
      });
    },
    doPayGmp: async function (payedPrice, isDiscount) {
      const payedAmount = this.roundTry2(payedPrice);
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }
      let removeIndex = [];
      let tempGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: 0,
        payedPrice: payedAmount,
        status: "Kalan"
      };
      let vm = this;
      this.paymentGroups.forEach((item) => {
        tempGroup.rowIndex = uuid.v1();
        if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
          tempGroup.entries = tempGroup.entries.concat(item.entries);
          // tempGroup.payedPrice = Math.round((tempGroup.payedPrice + item.payedPrice) * 1000) / 1000;
          removeIndex.push(item.rowIndex);
        }
      });
      let posSaleItems = [];
      var saleDto = {
        name: "İçecek",
        price: payedAmount,
        quantity: 1,
        kdv: 10
      }
      posSaleItems.push(saleDto);
      this.isLoading = true;
      if (isDiscount) {
        this.isLoading = false;
        if (this.selectedPaymentGroup.length == 0) {
          this.selectedPaymentGroup = this.paymentGroups;
        }
        let removeIndex = [];
        let tempGroup = {
          rowIndex: uuid.v1(),
          entries: [],
          totalPrice: 0,
          payedPrice: payedAmount,
          status: "Kalan"
        };
        let vm = this;

        this.paymentGroups.forEach((item) => {
          tempGroup.rowIndex = uuid.v1();
          if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
            tempGroup.entries = tempGroup.entries.concat(item.entries);
            tempGroup.payedPrice = this.roundTry2(tempGroup.payedPrice + item.payedPrice);
            removeIndex.push(item.rowIndex);
          }
        });

        let removedPaymentGroup = [];

        this.paymentGroups.forEach((x, index) => {
          if (!removeIndex.some(rm => rm == x.rowIndex)) {
            removedPaymentGroup.push(vm.paymentGroups[index]);
          }
        });
        removedPaymentGroup.push(tempGroup);

        this.paymentGroups = removedPaymentGroup;

        this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
        this.selectedPaymentGroup = [];

        this.reCalculatePaymentGroup();

        let orderPayment = {
          id: uuid.v1(),
          paymentMethod: this.selectedPaymentMethod,
          price: payedAmount,
          value: isDiscount ? this.paymentDiscount.value : null,
          unit: isDiscount ? this.paymentDiscount.unit : null,
          description: isDiscount ? this.paymentDiscount.description : null
        };
        this.orderPayments.push(orderPayment);
        // posTransactionId:"" // successden dönen pos fiş id orderpaymentin içine
        this.toggleCalc = false;
        this.commitIfFullyPaid();
      } else {
        this.isPosSettlementInProgress = true;
        const posStartedAt = Date.now();
        logSelfServiceManualEvent(SelfServiceEventType.PosSaleRequested, Object.assign(
          this.posTelemetryBase(payedAmount),
          { bridge: "create (GMP)", posPaymentType: this.posPaymentTypeForSelectedMethod(), itemCount: posSaleItems.length }
        ));
        try {
          let data;
          try {
            const response = await this.fetchWithTimeout(process.env.VUE_APP_POS_API + "create", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                PaymentType: this.posPaymentTypeForSelectedMethod(),
                SaleItems: posSaleItems,
              }),
            }, this.posSaleTimeoutMs());
            data = await response.json();
          } catch (err) {
            // İstek POS'a ulaşmış olabilir: sonuç bilinmiyor → kasiyere POS'u kontrol ettir.
            await this.resolveUnknownPosResult(payedAmount, isDiscount, {
              reason: err && err.name === "AbortError" ? "timeout" : "network",
              message: err && err.message,
              durationMs: Date.now() - posStartedAt
            });
            return;
          }
          this.isLoading = false;
          if (data.statusCode == 200) {
            const resultData = data.data || data;
            logSelfServiceManualEvent(SelfServiceEventType.PosSaleSucceeded, Object.assign(
              this.posTelemetryBase(payedAmount),
              { statusCode: data.statusCode, durationMs: Date.now() - posStartedAt }
            ));
            this.recordPosPayment(payedAmount, isDiscount, resultData);
          } else {
            logSelfServiceManualEvent(SelfServiceEventType.PosSaleFailed, Object.assign(
              this.posTelemetryBase(payedAmount),
              { outcome: "declined", statusCode: data.statusCode, message: data.message, durationMs: Date.now() - posStartedAt }
            ));
            this.$fire({
              title: data.message,
              text: "",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: data.message,
              text: "",
              position:'center'
            });
          }
        } finally {
          this.isLoading = false;
          this.isPosSettlementInProgress = false;
        }
      }
    },
    calculateTotalOriginPrice: function (selectedGroups) {
      let selectedPrice = 0;
      selectedGroups.forEach(item => {
        item.entries.forEach(entry => {
          selectedPrice += entry.originPrice;
        })
      });
      return Math.round(selectedPrice * 100) / 100;
    },
    commitPay(payedPrice,isDiscount){
      console.log('tamamlandı commit');
      const payedAmount = this.roundTry2(payedPrice);
      if (this.selectedPaymentGroup.length == 0) {
        this.selectedPaymentGroup = this.paymentGroups;
      }
      if (this.cloneCurrentCart.customer) {
        let cart = this.cloneCurrentCart;
        cart.cartEntries.forEach(x => {
          x.categoryId = x.categories[0].id;
        });
      }
      let removeIndex = [];
      let tempGroup = {
        rowIndex: uuid.v1(),
        entries: [],
        totalPrice: 0,
        payedPrice: payedAmount,
        status: "Kalan"
      };
      let vm = this;
      this.paymentGroups.forEach((item) => {
        tempGroup.rowIndex = uuid.v1();
        if (vm.selectedPaymentGroup.some(s => s.rowIndex == item.rowIndex)) {
          console.log(item);
          tempGroup.entries = tempGroup.entries.concat(item.entries);
          tempGroup.payedPrice = this.roundTry2(tempGroup.payedPrice + item.payedPrice);
          removeIndex.push(item.rowIndex);
        }
      });

      let removedPaymentGroup = [];
      this.paymentGroups.forEach((x, index) => {
        if (!removeIndex.some(rm => rm == x.rowIndex)) {
          removedPaymentGroup.push(vm.paymentGroups[index]);
        }
      });
      removedPaymentGroup.push(tempGroup);
      this.paymentGroups = removedPaymentGroup;
      this.separatePaymentPrice = this.calculateSelectedRemainingPrice(this.selectedPaymentGroup);
      this.selectedPaymentGroup = [];
      this.reCalculatePaymentGroup();
      let orderPayment = {
        id: uuid.v1(),
        paymentMethod: this.selectedPaymentMethod,
        price: payedAmount,
        value: isDiscount ? this.paymentDiscount.value : null,
        unit: isDiscount ? this.paymentDiscount.unit : null,
        description: isDiscount ? this.paymentDiscount.description : null
      };
      this.orderPayments.push(orderPayment);
      this.toggleCalc = false;
      this.$vs.notify({
            color: "success",
            title: "Tebrikler",
            text: payedAmount + " TL Değerinde Ödeme Gerçekleşti."
          });
    },
    openQrReader(amount,isDiscount) {
        this.$refs.qrReader.isActive = true;
        this.$refs.qrReader.isWallet = true;
        this.$refs.qrReader.amount = amount.toFixed(2);
        this.$refs.qrReader.isDiscount = isDiscount;
      },
    calculateSelectedRemainingPrice: function (selectedGroups) {
      let selectedPrice = 0;
      selectedGroups.forEach(item => {
        selectedPrice += (item.totalPrice - item.payedPrice);
      });
      return this.roundTry2(selectedPrice);
    },
    closeCalculatorPage() {
      this.isCalculatorPageActive = false;
    },
    closePaymentPopup() {
      logSelfServiceManualEvent(SelfServiceEventType.PaymentFlowCancelled, {
        totalPrice: this.totalPrice,
        entryCount: this.currentCart && this.currentCart.cartEntries ? this.currentCart.cartEntries.length : 0
      });
      this.isActive = false;
    },
    handlePopupUpdate(newValue) {
      if (this.isPaymentStarted) {
        this.isActive = true;
      }
      if (!newValue) {
        this.closeCalcIfOpen();
        this.$store.dispatch("selfservice/setSessionCarts", null);
      }
    },
    syncSession() {
      if (this.isRestoring) return;
      this.$store.dispatch("selfservice/setPaymentSessionState", {
        isActive: this.isActive,
        cloneCurrentCart: this.cloneCurrentCart,
        paymentGroups: this.paymentGroups,
        orderPayments: this.orderPayments,
        discounts: this.discounts,
        isPaymentStarted: this.isPaymentStarted,
        isPieced: this.isPieced
      });
    }
  },
  beforeDestroy() {
    const popups = document.querySelectorAll('body > .vs-component.con-vs-popup');
    popups.forEach(popup => {
      const inner = popup.querySelector('#orderList');
      if (inner) popup.remove();
    });
  },
  created() {
    // Vuesax Ghost Popup Cleanup: Remove any existing 'orderList' popups from body
    // This prevents overlapping divs/duplicate UI when HMR occurs or components are recreated improperly
    const existingPopups = document.querySelectorAll('body > .vs-component.con-vs-popup');
    existingPopups.forEach(popup => {
      const inner = popup.querySelector('#orderList');
      if (inner) {
        popup.remove();
      }
    });

    this.checkPosDevice();
    this.isPaymentStarted = false;

    const session = this.$store.getters["selfservice/getPaymentSessionState"];
    
    const hasPayments = session && session.orderPayments && session.orderPayments.length > 0;
    const hasDiscounts = session && session.discounts && session.discounts.length > 0;
    
    if (session && (session.isActive || hasPayments || hasDiscounts)) {
      if (session.cloneCurrentCart) {
        this.cloneCurrentCart = _.cloneDeep(session.cloneCurrentCart);
      }
      if (session.paymentGroups) {
        this.paymentGroups = _.cloneDeep(session.paymentGroups);
      }
      if (session.orderPayments) {
        this.orderPayments = _.cloneDeep(session.orderPayments);
      }
      if (session.discounts) {
        this.discounts = _.cloneDeep(session.discounts);
      }
      
      const sessionPaymentMethods = this.$store.getters["selfservice/getPaymentMethods"];
      console.log("sessionPaymentMethods:", sessionPaymentMethods);
      console.log("VUE_APP_CREDIT_PAYMENT_ID:", process.env.VUE_APP_CREDIT_PAYMENT_ID);
      if (sessionPaymentMethods && sessionPaymentMethods.length > 0) {
        const creditCardMethod = sessionPaymentMethods.find(m => m.id == process.env.VUE_APP_CREDIT_PAYMENT_ID);
        console.log("Found creditCardMethod:", creditCardMethod);
        if (creditCardMethod) {
          this.$store.dispatch("selfservice/setSelectedPaymentMethod", creditCardMethod);
        } else {
          this.$store.dispatch("selfservice/setSelectedPaymentMethod", sessionPaymentMethods[0]);
        }
      }

      this.isPaymentStarted = session.isPaymentStarted;
      this.isPieced = session.isPieced;
    }
  },

};
</script>

<style>
/* Fiş bileşeni ekranda görünmez; print-js this.$el ile klonlar */
/* Printer2 kökü #printerDiv2; gizleme asıl Printer2.vue’de — burada yüksek özgüllükle yedek (eski #printerDiv2 left:30% mobil sepette hayalet metin üretiyordu) */
.selfservice-printer2-offscreen#printerDiv2 {
  position: fixed !important;
  left: -9999px !important;
  top: 0 !important;
  width: 80mm;
  max-width: 80mm;
  pointer-events: none !important;
  z-index: -1 !important;
  overflow: hidden;
}

.payment-log {
  border-bottom: .1rem solid black
}

.payment-history::-webkit-scrollbar {
  height: 0;
  width: 0;
}

.payment-history {
  border: .1rem solid black;
  border-left: none;
  border-top: none;
  border-bottom: none;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-radius: 1rem;
  background: #FFD1D1;
  overflow: auto;
  max-height: 185px;
}

@media (min-width: 768px) {
  #orderList #orderListTable .vs-table--content {
    height: calc(100vh - 385px);
  }
}

@media (max-width: 767px) {
  #orderList #orderListTable .vs-table--content {
    height: auto !important;
    min-height: 6rem;
    max-height: min(38vh, 280px);
    overflow: auto !important;
    -webkit-overflow-scrolling: touch;
  }
}

.calc-button .includeIconOnly {
  width: unset !important;
  height: unset !important;
}

.calc-button {
  padding: 1rem 0.5rem !important;
  width: fit-content;
  display: flex;
}

.calc-button .large-icon i {
  font-size: 2.5rem !important;
  color: var(--vs-primary);
}

.calc-button .small-icon i {
  font-size: 1.5rem !important;
}

.info-row {
  padding: 0.75rem .75rem !important;
  border-top: 1px solid;
  background: #F9F5F5 !important;
  font-size: 1.1rem !important;
  padding-bottom: 0 !important;
}

#orderList .vs-popup .vs-popup--content {
  height: 97vh !important;
  max-height: 100vh !important;
  overflow: hidden;
  padding: 0 !important;
  margin: 0 !important;
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

#orderList .data-list-container {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-width: 100%;
}

#orderList .data-list-container .payment-table-panel {
  flex: 1 1 auto;
  min-height: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

#orderList .payment-table-panel #orderListTable,
#orderList .payment-table-panel > .vs-con-table {
  flex: 1 1 auto;
  min-height: 0;
  max-width: 100%;
}

#orderList .payment-footer-stack {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  border-top: 1px solid rgba(74, 44, 42, 0.08);
}

#orderList .payment-summary-sticky {
  position: relative;
  z-index: 5;
}

@media (min-width: 768px) {
  #orderList .payment-summary-sticky {
    position: sticky;
    bottom: 0;
  }
}

#orderList #orderListTable .con-tablex.vs-table--content {
  max-width: 100%;
}

#orderList #orderListTable .vs-con-tbody.vs-table--tbody {
  overflow-x: hidden !important;
  max-width: 100%;
}

#orderList #orderListTable .vs-table.vs-table--tbody-table {
  table-layout: fixed !important;
  width: 100% !important;
  max-width: 100%;
}

/* multiple: 1. sütun checkbox — sabit dar sütun, içerik ortada */
#orderList #orderListTable .vs-table--tbody-table th.td-check,
#orderList #orderListTable .vs-table--tbody-table td.td-check {
  width: 3rem !important;
  min-width: 3rem !important;
  max-width: 3rem !important;
  padding: 0.35rem 0.2rem !important;
  box-sizing: border-box;
  vertical-align: middle !important;
  text-align: center !important;
}

#orderList #orderListTable .vs-table--tbody-table td.td-check .con-td-check,
#orderList #orderListTable .vs-table--tbody-table th.td-check .con-td-check {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 auto !important;
  padding: 4px !important;
  box-sizing: border-box;
}

#orderList #orderListTable .vs-table--tbody-table td.td-check .con-vs-checkbox,
#orderList #orderListTable .vs-table--tbody-table th.td-check .con-vs-checkbox {
  margin-left: auto !important;
  margin-right: auto !important;
}

/* multiple: 1=checkbox, 2=ürün (+ ekstra alt satır), 3=fiyat */
#orderList #orderListTable .vs-table--tbody-table th:nth-child(2),
#orderList #orderListTable .vs-table--tbody-table td:nth-child(2),
#orderList #orderListTable .payment-th-product,
#orderList #orderListTable .payment-td-product {
  width: 72%;
  max-width: 72%;
  box-sizing: border-box;
  word-break: break-word;
  overflow-wrap: anywhere;
}

#orderList #orderListTable .vs-table--tbody-table th:nth-child(3),
#orderList #orderListTable .vs-table--tbody-table td:nth-child(3),
#orderList #orderListTable .payment-th-price,
#orderList #orderListTable .payment-td-price {
  width: 28%;
  max-width: 28%;
  min-width: 4.75rem;
  box-sizing: border-box;
  vertical-align: middle !important;
  white-space: normal;
}

#orderList #orderListTable .payment-product-name {
  margin-bottom: 0.15rem;
}

#orderList #orderListTable .payment-entry-extras {
  margin: 0.2rem 0 0.35rem;
  padding: 0 0.15rem;
}

#orderList #orderListTable .payment-entry-extra-line {
  margin: 0.08rem 0;
  font-size: 0.68rem !important;
  font-weight: 500 !important;
  line-height: 1.35;
  color: rgba(90, 52, 50, 0.78) !important;
  letter-spacing: 0.01em;
}

#orderList #orderListTable .payment-entry-recipe-line {
  margin-top: 0.12rem;
}

#orderList .order-list-table-tr {
  height: auto !important;
  min-height: 0 !important;
}

#orderList .payment-summary-bar {
  background: linear-gradient(180deg, #2f2826 0%, #25201e 100%) !important;
  flex-wrap: wrap;
  align-items: center;
  min-height: auto !important;
  padding: 0.85rem 0.75rem !important;
  box-sizing: border-box;
  max-width: 100%;
  flex-shrink: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.12);
}

#orderList .payment-summary-bar > .payment-summary-bar-col:nth-child(1) {
  justify-content: center !important;
}

#orderList .payment-summary-bar > .payment-summary-bar-col:nth-child(1) .w-auto.flex.align-center,
#orderList .payment-summary-bar > .payment-summary-bar-col:nth-child(1) .d-flex.align-center {
  width: 100%;
  max-width: 100%;
  justify-content: center !important;
  flex-wrap: wrap;
  text-align: center;
}

#orderList .payment-summary-bar .price-label {
  color: rgba(255, 248, 240, 0.82) !important;
  font-size: 0.8rem !important;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  font-weight: 600 !important;
}

#orderList .payment-summary-bar .price {
  color: #f4e4bc !important;
  font-size: 1.65rem !important;
  line-height: 1.2 !important;
  font-weight: 700 !important;
  letter-spacing: -0.02em;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.35);
}

#orderList .payment-summary-bar .payment-summary-bar-col:last-of-type .price {
  color: #c8f5d4 !important;
}

@media (max-width: 767px) {
  #orderList .payment-summary-bar {
    flex-direction: column;
    align-items: stretch;
    gap: 0.35rem;
    padding: 0.45rem 0.5rem !important;
  }

  #orderList .payment-summary-bar .price-label {
    font-size: 0.65rem !important;
    letter-spacing: 0.03em;
  }

  #orderList .payment-summary-bar .price {
    font-size: 1.05rem !important;
    line-height: 1.15 !important;
  }

  #orderList .payment-summary-bar .payment-print-toggle {
    padding: 0.2rem 0.5rem;
  }

  #orderList .payment-summary-bar .payment-print-checkbox {
    font-size: 0.68rem !important;
  }

  #orderList .payment-summary-bar > .payment-summary-bar-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 auto !important;
    margin-left: 0 !important;
    justify-content: center !important;
  }

  #orderList .payment-summary-bar .flex.justify-flex-end {
    justify-content: center !important;
  }

  #orderList .payment-summary-bar .price-label,
  #orderList .payment-summary-bar .price {
    margin-right: 0.35rem !important;
    margin-left: 0 !important;
  }

  #orderList .payment-summary-bar-print {
    order: 2;
  }

  #orderList .payment-summary-bar-col:first-of-type {
    order: 1;
  }

  #orderList .payment-summary-bar-col:last-of-type {
    order: 3;
  }
}

#orderList .order-list-bottom-row {
  flex-wrap: wrap;
  max-width: 100%;
  flex-shrink: 0;
}

@media (max-width: 767px) {
  /* Mobil: personel adı / tarih satırı (üst kırmızı alan) gizli */
  #orderList .payment-screen-meta.info-row {
    display: flex !important;
    padding: 0.35rem 0.65rem !important;
    font-size: 0.8rem !important;
  }

  #orderList .order-list-bottom-side,
  #orderList .order-list-bottom-main {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 auto !important;
  }

  #orderList .order-list-calc-col {
    display: flex;
    justify-content: center;
    order: 10;
    margin-top: 0.25rem;
  }

  #orderList .payment-actions-host {
    justify-content: center !important;
  }

  #orderList .payment-main-actions-row {
    flex-wrap: nowrap !important;
    flex-direction: row !important;
    justify-content: stretch !important;
    align-items: stretch !important;
    gap: 0.45rem;
    width: 100%;
    box-sizing: border-box;
  }

  #orderList .payment-main-actions-col {
    width: 50% !important;
    max-width: 50% !important;
    flex: 1 1 50% !important;
    min-width: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    justify-content: center !important;
  }

  #orderList .order-list-wide-btn {
    width: 100% !important;
    max-width: 100% !important;
  }

  #orderList .payment-main-actions-row .pay-toolbar-btn.order-list-wide-btn {
    min-height: 2.65rem !important;
    font-size: clamp(0.72rem, 3vw, 0.88rem) !important;
    padding: 0.45rem 0.4rem !important;
    line-height: 1.2 !important;
    white-space: normal !important;
  }

  #orderList .payment-main-actions-row .pay-toolbar-btn.order-list-wide-btn .vs-button--text {
    font-size: inherit !important;
    line-height: 1.2 !important;
  }

  #orderList #orderListTable .vs-table--tbody-table th.td-check,
  #orderList #orderListTable .vs-table--tbody-table td.td-check {
    width: 2.75rem !important;
    min-width: 2.75rem !important;
    max-width: 2.75rem !important;
    padding: 0.3rem 0.15rem !important;
  }

  #orderList .column-head-text {
    font-size: clamp(0.72rem, 3.2vw, 1rem) !important;
  }

  #orderList .tr-text {
    font-size: clamp(0.72rem, 3vw, 1rem) !important;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  #orderList .tr-text-child {
    font-size: clamp(0.65rem, 2.8vw, 0.95rem) !important;
  }

  #orderList .price-label {
    font-size: clamp(0.75rem, 3vw, 1rem) !important;
  }

  #orderList .price {
    font-size: clamp(1rem, 4.5vw, 1.5rem) !important;
    line-height: 1.2 !important;
  }

  #orderList .info-row {
    flex-wrap: wrap !important;
    font-size: clamp(0.8rem, 3.2vw, 1rem) !important;
  }

  #orderList .info-row > .vs-col {
    width: 100% !important;
    max-width: 100% !important;
    justify-content: flex-start !important;
    margin-bottom: 0.25rem;
  }

  #orderList .info-row > .vs-col:last-child {
    margin-bottom: 0;
  }

  /* İndirim / parçalı ödeme (%) FAB — mobilde daha küçük */
  #orderList .payment-calc-fab.calc-button {
    padding: 0.3rem 0.4rem !important;
    border-radius: 10px !important;
  }

  #orderList .payment-calc-fab .large-icon i {
    font-size: 1.2rem !important;
  }

  #orderList .payment-calc-fab .small-icon i {
    font-size: 0.8rem !important;
  }
}

#orderList .vs-popup {
  border-radius: 2rem !important;
}

#orderList .vs-popup .vs-popup--header {
  display: none;
}

.payment-label {
  font-size: 1.25rem !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-top-left-radius: 2rem !important;
  border-top-right-radius: 2rem !important;
}

.payment-label i {
  font-size: 3rem !important;
  margin-right: 2rem !important;
}

#orderList .vs-table--tbody-table tr {
  background: none;
}

#orderList .giftsOpenerButton {
  z-index: 600;
}

#orderListTable .vs-table--content .vs-con-tbody .vs-table .vs-table--thead {
  background: #FFD1D1;
}

#orderListTable .con-tablex .vs-con-tbody .vs-table .vs-table--thead tr th .vs-table-text {
  border: none !important;
}

#orderListTable .con-tablex .vs-con-tbody .vs-table .vs-table--thead tr th {
  padding-bottom: 0 !important;
}

.column-head-text {
  font-size: 1.1rem !important;
  color: #543633 !important;
}

.tr-text {
  font-size: 1.1rem !important;
  font-weight: bold;
}

.tr-text-child {
  font-size: 1rem !important;
  font-weight: 600;
  font-style: italic;
}

.vs-table-primary .is-selected {
  background: #B8EEB8 !important;
}

.price-label {
  font-size: 1.1rem !important;
  color: #543633 !important;
  font-weight: 600 !important;
}

.price {
  font-size: 1.75rem !important;
  color: #543633 !important;
  line-height: 1.75rem !important;
}

.payed-row {
  color: rgb(130, 223, 130) !important;
  text-shadow: 0px 0px 3px rgb(226, 226, 226);
}

/* === Ödeme ekranı premium POS shell (yalnızca #orderList) === */
#orderList .payment-screen-layout {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #f7f4f2 0%, #ebe6e2 55%, #e4deda 100%);
}

#orderList .payment-screen-header .payment-screen-header-btn.payment-label,
#orderList .payment-screen-header .vs-button.payment-label {
  border: none !important;
  border-radius: 0 !important;
  background: linear-gradient(135deg, #5a3432 0%, #422624 50%, #2c1816 100%) !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.22);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-weight: 700 !important;
  padding-top: 0.8rem !important;
  padding-bottom: 0.8rem !important;
  font-size: 1.05rem !important;
}

#orderList .payment-screen-header .payment-label i {
  font-size: 1.65rem !important;
  margin-right: 0.85rem !important;
  opacity: 0.92;
}

#orderList .payment-screen-meta.info-row {
  background: #ffffff !important;
  border-top: none !important;
  border-bottom: 1px solid rgba(74, 44, 42, 0.12) !important;
  padding: 0.65rem 1rem 0.8rem !important;
  font-size: 1rem !important;
  display: flex !important;
  position: relative !important;
  z-index: 10 !important;
}

#orderList .payment-screen-meta.info-row p,
#orderList .payment-screen-meta.info-row span,
#orderList .payment-meta-label,
#orderList .payment-meta-value,
#orderList .payment-meta-date,
#orderList .payment-meta-time {
  color: #3e2624 !important;
}

#orderList .payment-meta-label {
  font-size: 0.68rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  opacity: 0.85;
}

#orderList .payment-meta-value {
  font-size: 1.05rem;
  font-weight: 700;
}

#orderList .payment-meta-date,
#orderList .payment-meta-time {
  font-size: 0.82rem;
  padding: 0.28rem 0.7rem;
  background: rgba(90, 52, 50, 0.07);
  border-radius: 999px;
  border: 1px solid rgba(90, 52, 50, 0.08);
}

#orderList .payment-table-panel {
  margin: 0.75rem 0.85rem 0;
  background: #fff;
  border-radius: 14px;
  border: 1px solid rgba(74, 44, 42, 0.08);
  box-shadow: 0 10px 32px rgba(62, 38, 36, 0.07);
  width: calc(100% - 1.7rem);
  max-width: 100%;
  box-sizing: border-box;
}

#orderList .payment-table-panel .con-tablex,
#orderList .payment-table-panel > .vs-con-table {
  width: 100%;
  max-width: 100%;
}

@media (max-width: 767px) {
  #orderList .payment-table-panel {
    margin: 0.5rem 0 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    flex: 1 1 0;
    min-height: 0;
    border-radius: 0;
    border-left: none;
    border-right: none;
    box-shadow: 0 4px 18px rgba(62, 38, 36, 0.06);
  }

  #orderList .data-list-container {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  #orderList .payment-table-panel .con-tablex {
    width: 100% !important;
    max-width: 100% !important;
    min-height: 0;
  }

  #orderList .payment-table-panel #orderListTable .vs-table--content {
    width: 100% !important;
    max-width: 100% !important;
    min-height: 0;
    overflow: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  /* Tablo viewport genişliğinde kalsın; taşan sütun kaldırıldı (ekstra ürün altında) */
  #orderList #orderListTable .vs-con-tbody.vs-table--tbody {
    overflow-x: hidden !important;
    max-width: 100%;
  }

  #orderList #orderListTable .vs-table.vs-table--tbody-table {
    table-layout: fixed !important;
    min-width: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  #orderList .select-payment-type-buttons > .vs-button.pay-method-btn {
    min-height: 1.9rem !important;
    padding-top: 0.22rem !important;
    padding-bottom: 0.22rem !important;
  }

  #orderList .select-payment-type-buttons > .vs-button.pay-method-btn .vs-button--text {
    font-size: 0.62rem !important;
    line-height: 1.15 !important;
  }
}

#orderList #orderListTable .vs-table--content .vs-con-tbody .vs-table .vs-table--thead {
  background: linear-gradient(180deg, #f2ece9 0%, #e8e2df 100%) !important;
}

#orderList #orderListTable .column-head-text {
  color: #3a2a28 !important;
  font-size: 0.72rem !important;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  font-weight: 700 !important;
}

#orderList .order-list-table-tr.bg-secondary2 {
  background: rgba(90, 52, 50, 0.035) !important;
}

#orderList #orderListTable .vs-table--tbody-table .vs-table--td:not(.td-check),
#orderList #orderListTable .vs-table--tbody-table th:not(.td-check) {
  padding: 0.55rem 0.45rem !important;
  vertical-align: top;
}

#orderList .vs-table-primary .vs-table--tr.is-selected {
  background: linear-gradient(90deg, rgba(45, 138, 84, 0.18) 0%, rgba(45, 138, 84, 0.07) 100%) !important;
  box-shadow: inset 4px 0 0 #2d8a54;
}

#orderList .payment-print-toggle {
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.14);
}

#orderList .payment-print-checkbox {
  color: rgba(255, 250, 245, 0.95) !important;
  font-weight: 600 !important;
  font-size: 0.82rem !important;
}

#orderList .payment-actions-toolbar.order-list-bottom-row {
  background: linear-gradient(180deg, #fdfcfa 0%, #f5f1ef 100%);
  padding: 0.85rem 0.75rem 1.1rem;
  border-top: 1px solid rgba(74, 44, 42, 0.07);
  box-shadow: 0 -6px 22px rgba(62, 38, 36, 0.06);
}

#orderList .pay-toolbar-btn {
  border-radius: 12px !important;
  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;
  min-height: 3rem;
}

#orderList .pay-toolbar-btn:not(:disabled):hover {
  transform: translateY(-1px);
  filter: brightness(1.02);
}

#orderList .pay-toolbar-btn--ghost {
  border: 1px solid rgba(90, 52, 50, 0.38) !important;
  background: linear-gradient(180deg, #f2e8e4 0%, #e2d4cf 100%) !important;
  color: #141010 !important;
  text-shadow: none !important;
}

#orderList .pay-toolbar-btn--ghost .vs-button-background,
#orderList .pay-toolbar-btn--ghost .vs-button--background {
  opacity: 0 !important;
}

#orderList .pay-toolbar-btn--ghost .vs-button--text,
#orderList .pay-toolbar-btn--ghost span {
  color: #141010 !important;
}

#orderList .pay-toolbar-btn--ghost .vs-icon,
#orderList .pay-toolbar-btn--ghost i {
  color: #141010 !important;
}

#orderList .pay-toolbar-btn--primary {
  letter-spacing: 0.02em;
}

#orderList .pay-toolbar-btn--success {
  letter-spacing: 0.03em;
}

#orderList .select-payment-type-buttons {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 0.65rem !important;
  width: 100% !important;
  margin: 0.35rem 0 !important;
}

#orderList .payment-calc-fab {
  border-radius: 14px !important;
  border: 1px solid rgba(74, 44, 42, 0.1);
  background: linear-gradient(180deg, #fff 0%, #f7f3f1 100%) !important;
  box-shadow: 0 8px 20px rgba(62, 38, 36, 0.1);
}

#orderList .payment-history {
  border: 1px solid rgba(74, 44, 42, 0.12);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
}

#orderList .payment-log {
  border-bottom: 1px solid rgba(74, 44, 42, 0.08);
}

.swal2-container {
  z-index: 99999;
}
</style>
